import { create } from "zustand";

interface BrandingState {
  brandName: string | null;
  setBrandName: (name: string | null) => void;
}

export const useBrandingStore = create<BrandingState>((set) => ({
  brandName: null,
  setBrandName: (brandName) => set({ brandName }),
}));
